import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DatePicker } from '@shopify/polaris';

const propTypes = {
  initialValues: PropTypes.shape({
    start: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    end: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  }),

  onChange: PropTypes.func.isRequired,
  containerClass: PropTypes.string,

  // calprops
};

const defaultProps = {
  containerClass: ""
}

// TODO Setup some sort of mechanism to use a undefined initialDate to make it evident that it needs to be set
const AppDatePicker = (props) => {
  const { containerClass, initialValues, onChange, ...pickerProps } = props;

  const initialDate = initialValues.start ? new Date(initialValues.start) : new Date; // Pick start date if available, otherwise use today

  // Handle local calendar state for faster update of UI
  const [calState, setCalState] = useState({
    start: initialDate,
    end: initialValues.end ? new Date(initialValues.end) : initialDate, // end date is only relevant if range is enabled
    
    month: initialDate.getMonth(), 
    year: initialDate.getUTCFullYear(),
  });
  
  const handleMonthChange = (month, year) => {
    setCalState({ ...calState, month, year });
  }

  const handleCalendarChange = (newValues) => {
    const { start, end } = newValues;
    setCalState({ ...calState, start, end });
    onChange(newValues); // upstream echo
  }

  console.log("AppDatePicker: ", props);

  return(
    <div className={ containerClass }>
      <DatePicker
        selected={{ start: calState.start, end: calState.end }}
        onChange={ handleCalendarChange }
        
        month={ calState.month }
        year={ calState.year }
        onMonthChange={ handleMonthChange }
        {...pickerProps}
      />
    </div>
  );
}


AppDatePicker.propTypes = propTypes;
AppDatePicker.defaultProps = defaultProps;


export default AppDatePicker;